import React, { useMemo, useState } from "react";
import { Select } from "antd";
import SapaButton from "../../ui/Button/Button";

const TRANSACTION_FILTERS = [
  {
    field: "transaction_type",
    label: "Transaction Type",
    placeholder: "All transaction types",
    options: [
      { label: "All", value: "" },
      { label: "Credit", value: "credit" },
      { label: "Debit", value: "debit" },
    ],
  },
  {
    field: "status",
    label: "Status",
    placeholder: "All statuses",
    options: [
      { label: "All", value: "" },
      { label: "Success", value: "success" },
      { label: "Pending", value: "pending" },
      { label: "Failed", value: "failed" },
      { label: "Refund", value: "refund" },
      { label: "Canceled", value: "canceled" },
      { label: "Initiated", value: "initiated" },
    ],
  },
  {
    field: "payment_method",
    label: "Payment Method",
    placeholder: "All payment methods",
    options: [
      { label: "All", value: "" },
      { label: "Card", value: "CARD" },
      { label: "Bank Transfer", value: "BANK_TRANSFER" },
      { label: "Main Wallet", value: "WALLET_MAIN" },
      { label: "Commission Wallet", value: "WALLET_COMMISSION" },
      { label: "Payout Wallet", value: "WALLET_PAYOUT" },
    ],
  },
  {
    field: "service_category",
    label: "Service Category",
    placeholder: "All service categories",
    options: [
      { label: "All", value: "" },
      { label: "Airtime", value: "airtime" },
      { label: "Data", value: "data" },
      { label: "Electricity", value: "electricity" },
      { label: "Cable TV", value: "cable-tv" },
      { label: "Internet", value: "internet" },
      { label: "Betting", value: "betting" },
      { label: "Gift Card", value: "gift-card" },
      { label: "Crypto", value: "crypto" },
    ],
  },
  {
    field: "provider",
    label: "Provider",
    placeholder: "Provider name",
    options: [
      { label: "All", value: "" },
      { label: "Nomba Payment Service", value: "Nomba" },
      { label: "Swita", value: "Swita" },
      { label: "Airvend", value: "Airvend" },
      { label: "Shago", value: "Shago" },
      { label: "BuyPower", value: "BuyPower" },
    ],
  },
];

const USER_FILTERS = [
  {
    field: "status",
    label: "User Status",
    placeholder: "All statuses",
    options: [
      { label: "All", value: "" },
      { label: "Active", value: "active" },
      { label: "Blocked", value: "blocked" },
      { label: "Suspended", value: "suspended" },
    ],
  },
  {
    field: "tier",
    label: "KYC Tier",
    placeholder: "All tiers",
    options: [
      { label: "All", value: "" },
      { label: "Tier 1", value: 1 },
      { label: "Tier 2", value: 2 },
      { label: "Tier 3", value: 3 },
    ],
  },
];

const FilterModal = ({ type, visible, setVisible, onApplyFilter }) => {
  const [formData, setFormData] = useState({});

  const filters = useMemo(() => (type === "usersType" ? USER_FILTERS : TRANSACTION_FILTERS), [type]);

  const handleChange = (field, value) => {
    setFormData((current) => ({ ...current, [field]: value }));
  };

  const handleApplyFilter = () => {
    const cleanData = Object.fromEntries(
      Object.entries(formData).filter(([, value]) => value !== "" && value !== undefined && value !== null)
    );

    if (typeof onApplyFilter === "function") {
      onApplyFilter(cleanData);
    }
  };

  return (
    <div className="filter-modal">
      <div className="filter-modal-container">
        {filters.map((filter) => (
          <div className="filter-modal-inner" key={filter.field}>
            <p>{filter.label}</p>
            <Select
              allowClear
              className="filter-modal-select"
              options={filter.options}
              placeholder={filter.placeholder}
              value={formData[filter.field]}
              onChange={(value) => handleChange(filter.field, value)}
            />
          </div>
        ))}
        <div className="filter-modal-btn__container">
          <SapaButton
            label="Apply Filter"
            customClass="filter-modal-btn__fill"
            shape="round"
            buttonType="primary"
            onClick={handleApplyFilter}
          />
          <SapaButton
            label="Cancel"
            customClass="filter-modal-btn__transparent"
            shape="round"
            buttonType="transparent"
            onClick={() => setVisible(!visible)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
